import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

interface DeliveryTypeInfoSectionProps {
    title?: string;
    description: string;
}
const DeliveryTypeInfoSection: React.FC<
    React.PropsWithChildren<DeliveryTypeInfoSectionProps>
> = ({ title, description }) => {
    return (
        <Container>
            {title && <Title>{title}</Title>}
            <Description>{description}</Description>
        </Container>
    );
};

export default DeliveryTypeInfoSection;

const Container = styled.div({
    display: `flex`,
    alignItems: `start`,
    flexDirection: 'column',
    gap: aampeTheme.spacing(2),
});

const Title = styled.div({
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
});

const Description = styled(Title)({
    color: aampeTheme.colors.neutral09,
});
